export default __webpack_public_path__ + "static/media/confidential.68e97128.png";